export default "__VITE_ASSET__BvhKqVe___"